export default "__VITE_ASSET__CnnZn_6L__"